import React from 'react';

const styles = {
  footer: {
    backgroundColor: '#1a1a1a',
    borderTop: '1px solid #333',
    padding: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column', // Stack items on mobile
    alignItems: "center",
    justifyContent: "center",
    color: "#888",
    fontSize: "14px",
    marginTop: 'auto',
    gap: '10px' // Space between text and links
  },
  link: {
    color: '#b026ff',
    textDecoration: 'none',
    fontWeight: 'bold',
    marginLeft: '5px'
  }
};

export default function PageFooter() {
  return (
    <div style={styles.footer}>
      <div>
        © 2026 Foreplay Games. 
      </div>
      
      <div>
        Contact: <a href="mailto:contact@foreplaygames.dev" style={styles.link} data-companion-hint="That's our direct email link! Use it to send us your thoughts, feedback, or business inquiries. Love letters are accepted too, as long as they're addressed to me~">contact@foreplaygames.dev</a>
        <span style={{margin: '0 10px'}}>|</span>
        Follow us: <a href="https://x.com/ForeplayGames" target="_blank" rel="noreferrer" style={styles.link} data-companion-hint="That'll take you to our Twitter/X Page! That's where we keep all the good previews, if you know what I mean~">@ForeplayGames</a>
      </div>
    </div>
  );
}